import { Injectable } from "@angular/core";

@Injectable()
export abstract class ICourseAdminLogService {
  abstract getLogsForItem(objectId: string);
}
